var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "legend-chart" },
    _vm._l(_vm.datasets, function(dataset, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "legend-item",
          class: { linha: dataset.hidden },
          style: {
            cursor: "pointer",
            "--dataset-color": dataset.backgroundColor || dataset.borderColor
          },
          on: {
            click: function($event) {
              return _vm.toggleDataset(dataset.label)
            }
          }
        },
        [
          _c("span", {
            staticClass: "legend-color",
            style: {
              backgroundColor: dataset.backgroundColor || dataset.borderColor
            }
          }),
          _c("span", { staticClass: "legend-label" }, [
            _vm._v(_vm._s(dataset.label))
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }